import React, { useMemo } from 'react'
import { Box, FlagIcon, getFlagByCode, Icon, IndustriesIcon, MotivationsIcon } from '@maui/elements'
import { SearchResultDescription, SearchResultHeader, SearchResultPill, SearchResultPillMore, SearchResultTitle } from '../common'
import { getCountryCode } from '../../icons/ActorIcon'

export const TargetedIndustriesPill = ({ industries = [] }) => {
  if (!industries?.length) return null
  return (
    <Box pr='16px'>
      <SearchResultPill
        type={<Box textStyle='bodySmall'>Target Industries:</Box>}
        value={
          <Box display='flex' gap='4px'>
            <Box textStyle='buttonLabelSmall' display='flex' gap='4px'>
              <IndustriesIcon name={industries[0]?.name}/>
              {industries[0]?.name}
            </Box>
            <SearchResultPillMore values={industries}/>
          </Box>
        }
      />
    </Box>
  )
}

export const MotivationsPill = ({ motivations = [] }) => {
  if (!motivations?.length) return null
  return (
    <SearchResultPill
      type={<Box textStyle='bodySmall'>Motivations:</Box>}
      value={
        <Box display='flex' gap='spaceGapSmall'>
          <Box textStyle='buttonLabelSmall' display='flex' gap='spaceGapSmall'>
            <MotivationsIcon name={motivations[0]?.name || motivations[0]} />
            {motivations[0]?.name || motivations[0]}
          </Box>
          <SearchResultPillMore values={motivations}/>
        </Box>
      }
    />
  )
}

export const ActorSearchResult = ({ data }) => {
  const {
    id,
    name,
    description,
    aliases = [],
    industries,
    motivations,
    last_activity_time: date,
  } = data
  const icon = useMemo(() => {
    if (!data) return
    const countryCode = getCountryCode(data)
    return getFlagByCode(countryCode)
      ? <FlagIcon style={{ height: '32px', width: '32px' }} code={countryCode}/>
      : <Icon name='user-secret' size='lg' verticalAlign='-12.7px' color='colorActionPrimary'/>
  }, [data])

  return (
    <Box>
      <SearchResultHeader subHeaderText={'Threat Actor'} date={date} />
      <SearchResultTitle
        titleIcon={icon}
        name={name}
        url={`/actors/${id}`}
      />
      <Box>
        {
          aliases.length > 0 && (
            <Box pt='8px' pb='8px' width='80%'>
              <Box
                textStyle='caption'
                fontSize='10px'
                color='colorTextDeemphasis'
                textOverflow='ellipsis'
                overflow='hidden'
                whiteSpace='nowrap'
              >
                {aliases.map(alias => alias.name).join(', ')}
              </Box>
            </Box>
          )
        }
        <Box pt='8px' pb='8px'>
          <Box display='flex'>
            <TargetedIndustriesPill industries={industries} />
            <Box>
              <MotivationsPill motivations={motivations}/>
            </Box>
          </Box>
        </Box>
      </Box>
      <SearchResultDescription description={description}/>
    </Box>
  )
}
